import React from 'react';
import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined';

const items = [
  {
    icon: <VisibilityOutlinedIcon fontSize="inherit" />,
    title: 'See exactly where your tax goes',
    sub: 'Visual bands show PAYE, NI, pension & loans',
  },
  {
    icon: <SpeedOutlinedIcon fontSize="inherit" />,
    title: 'Instant salary adjustments',
    sub: 'Edit salary and watch bands update in real-time',
  },
  {
    icon: <UpdateOutlinedIcon fontSize="inherit" />,
    title: 'Always up-to-date with HMRC',
    sub: '2025/26 rates incl. pensions & student loans',
  },
  {
    icon: <DevicesOutlinedIcon fontSize="inherit" />,
    title: 'No downloads or sign-ups',
    sub: 'Works perfectly on desktop, tablet and mobile',
  },
];

export default function WhyChoose() {
  return (
    <Box component="section" sx={{ py: { xs: 6, md: 10 }, bgcolor: '#F7F7F9' }}>
      <Container maxWidth="md">
        <Typography variant="h2" sx={{ fontSize: { xs: 22, md: 28 }, textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          Why people choose SalaryTools
        </Typography>
        <Grid container spacing={{ xs: 2.5, md: 3 }}>
          {items.map((it, i) => (
            <Grid key={i} size={{ xs: 12, sm: 6 }}>
              <Stack 
                direction={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'center', sm: 'flex-start' }}
                spacing={2} 
                sx={{ 
                  textAlign: { xs: 'center', sm: 'left' }
                }}
              >
                <Box
                  aria-hidden
                  sx={{
                    width: 36, height: 36, borderRadius: '50%',
                    display: 'grid', placeItems: 'center',
                    bgcolor: 'primary.50', color: 'primary.main', fontSize: 22,
                    flexShrink: 0,
                  }}
                >
                  {it.icon}
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 700 }}>{it.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{it.sub}</Typography>
                </Box>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}